// import('scss/app.scss');
require("stylesheets/application.scss");

// This here's the main file for applicant-facing pages

require("application_entry");
